export default {
    // START:: FILTERED PRODUCT GETTER
    filteredProducts(state) {
        return state.filterResultData;
    },
    // END:: FILTERED PRODUCT GETTER
};
